import Vue from 'vue';

jQuery(document).ready(function(){
    var $ = jQuery;

    $(".procesio-calculator").each(function(){
      var nodeEl = $(this);
        var app = new Vue({
          el: nodeEl[0],
          data: {
            NumberOfDevelopers : 3,
            NumberOfProcesses : 100,
            NumberOfSteps : 50,
            NumberOfExecutionsPerProcess : 100,

            PlanType: "Business",

            Plan: {
              Business : 1, 
              Development : 2
            },
            PlanActionRunsValues: {
              Business : 120000, 
              Development : 700000
            },
            PlanPriceValues: {
              Business : 1200, 
              Development : 6000
            },
            PlanSugerat:{
              PlanAles : 0,
              NumberOfPacks : 0,
              AnualCost : 0,
              ContactSales : 0       
            },
            step:0
          },
          mounted:function(){
              var vm = this;
              console.log("Vue Started");
              //vm.PlanType = nodeEl.attr("tip_plan");
          },
          computed:{
              stepsStyle:function(){
                var vm = this;
                var obj = {
                  "left": -100*vm.step + "%"
                }

                console.log(vm.step);
               return obj;
              }
          },
          methods:{
            calculateResult:function(){
                var vm = this;
                vm.step = 1;
                vm.PlanType = "Business";
                var PlanCalculat = vm.Plan.Business;//De la acest plan plec 

                var ActionRuns = vm.NumberOfProcesses * vm.NumberOfSteps * vm.NumberOfExecutionsPerProcess;
                var PlanActionRuns = vm.PlanActionRunsValues.Business;//pentru ca <PlanCalculat = Plan[vm.PlanType]>
                var Plan_price = vm.PlanPriceValues.Business;//pentru ca <PlanCalculat = Plan[vm.PlanType]>
                
                var NoOfPacks = Math.ceil((ActionRuns/PlanActionRuns));
                //Console.Write("1.1. Numar de packuri: " + NoOfPacks + "\n");
                var AnualCost = NoOfPacks * Plan_price;
                //Console.Write("1.2. Cost anual: " + AnualCost + "\n");
                if (AnualCost >= Math.ceil((ActionRuns/(vm.PlanActionRunsValues.Development))) * vm.PlanPriceValues.Development)
                {
                  
                  PlanCalculat = vm.Plan.Development;
                  PlanActionRuns = vm.PlanActionRunsValues.Development;
                  Plan_price = vm.PlanPriceValues.Development;
                  vm.PlanType = "Development";
                  NoOfPacks = Math.ceil((ActionRuns/PlanActionRuns));
                  //Console.Write("2.1. Numar de packuri: " + NoOfPacks + "\n");			
                  AnualCost = NoOfPacks * Plan_price;
                  //Console.Write("2.2. Cost anual: " + AnualCost + "\n");
                }

                vm.PlanSugerat.PlanAles = PlanCalculat;
                vm.PlanSugerat.NumberOfPacks = NoOfPacks;
                vm.PlanSugerat.ActionRuns = vm.NumberOfProcesses * vm.NumberOfSteps * vm.NumberOfExecutionsPerProcess;
                vm.PlanSugerat.AnualCost = AnualCost;
                vm.PlanSugerat.ContactSales = AnualCost >= 50000 ? true : false;
            },
            backToCalculate:function(){
                var vm = this;
                vm.step = 0;
                console.log(vm.step);
            }
          }
        });
    });

    
   
    
});
